<template>
    <keep-alive>
    <div :id="div_id" ref="skyFormWrapper">
        <button :id="btn_id">{{"formElementLabelSubmit" | translate}}</button>
    </div>
    </keep-alive>
</template>

<script>

    // Don't understand why this is necessary...
    // however, like thtat works again
    import URLSearchParams from '@ungap/url-search-params'

    /**
     * Be warned: This is only a thin wrapper that
     * enables using sky forms through vue.
     * Shortcomings:
     * -> Every form can only be used **once** globally in the DOM
     *    this is due the lack of id prefixing in sky forms
     *
     *    Workaround: Register the form a second time with another name
     *
     * -> Reloading is done by unmounting (v-if..)
     *    The form is only loaded on mount (e.g prefill and stuff...)
     */
    export default {
        name: "SkyFormLoader",
        props: { formName: String,
            params: {type: [String,Object], required: false, default: ""}},
        data() {
            return {
                div_id: 'vueskyform'+this._uid+this.formName,
                btn_id: 'vueskyform'+this._uid+this.formName+'btn',
            }
        },
        mounted() {
            const paramstr = typeof this.params == 'string'?
                this.params : new URLSearchParams(Object.entries(this.params)).toString()

            const loaded = () => {
                const form = this.$refs.skyFormWrapper.querySelector( "form" );
                Sky.FormBuilder.registerForm( this.formName, this.btn_id,
                    {onSuccess: this.submitCallback, onError: this.submitCallbackError, onBeforeSubmit: this.submitCallbackBeforeSend, formParams: paramstr} )
            }
            Sky.FormBuilder.loadForm(this.formName, paramstr, this.$refs.skyFormWrapper, loaded )
            console.log("init form")
        },
        methods: {
            submitCallback(...args) {
                console.log("suc")
                this.$emit("success", ...args )
            },
            submitCallbackError(...args) {
                console.log("err")
                this.$emit("error", ...args )
            },
            submitCallbackBeforeSend(...args) {
                console.log("before")
                this.$emit("beforeSubmit", ...args )
                return true;
            }
        },




    }
</script>

<style scoped>

</style>